// extracted by css-extract-rspack-plugin
export default {"modalBody":"_f807d2ac","mediumPadding":"_83ef1afb","noPadding":"_26cdc227"};